export interface StartAppParams {
  code?: string; // Referral code
  userId?: string; // User ID for profile link
}

export const getStartAppParams = (): StartAppParams | null => {
  try {
    const data = window.Telegram.WebApp.initDataUnsafe.start_param;
    if (!data) return null;
    const parsed: StartAppParams = JSON.parse(atob(data));
    return parsed;
  } catch (err) {
    console.error(err);
    return null;
  }
};
